import { useMobilityVoucherApi } from "./useMobilityVoucherApi";
import qs from "qs";
import { RootSubscriptionGelAllResponse, SubscriptionInputGetAll } from '../interfaces/Subscription';
import { CustomerInputGetAll, RootCustomerGetAllResponse } from '../interfaces/Customer';
import {useContext} from "react";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";

export const useVoucherActions = () => {
  const { GET, POST, PUT } = useMobilityVoucherApi();
  const {  globalData: { user } } = useContext(GlobalContext);
  const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);
  const allDealers: any[] = user.dealers?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

  async function getSubscription(filters: any) {
    let params = {
      categories: filters.categoryName ? filters.categoryName : undefined,
      productName: filters.productName ? filters.productName : undefined,
      sku: filters.sku ? filters.sku : undefined,
      offset: filters.offset ? filters.offset : undefined,
      limit: filters.limit ? filters.limit : undefined,
      sortBy: filters.sort ? filters.sort : undefined,
      order: filters.order ? filters.order : undefined,
      tenants: filters.legalEntities ? filters.legalEntities : allLegalEntities,
      dealers: filters.dealers? filters.dealers  : [],
    };
    let voucherGetAllResponse: RootSubscriptionGelAllResponse = await GET("/mobility-voucher/subscription", true, {
      params,
      paramsSerializer: (params: SubscriptionInputGetAll) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
    });
    return {
      totalElements: voucherGetAllResponse?.result?.totalElements,
      content: voucherGetAllResponse?.result?.content
    };
  }

  async function getOrders(filters: any) {
    let params = {
      lastName: filters.lastName ? filters.lastName : undefined,
      taxCode: filters.taxCode ? filters.taxCode : undefined,
      companyName: filters.companyName ? filters.companyName : undefined,
      vatNumber: filters.vatNumber ? filters.vatNumber : undefined,
      email: filters.email ? filters.email : undefined,
      status: filters.status ? filters.status : undefined,
      voucherCode: filters.voucherCode ? filters.voucherCode : undefined,
      voucherState: filters.voucherState ? filters.voucherState : undefined,
      dateFrom: filters.dateFrom ? filters.dateFrom : undefined,
      dateTo: filters.dateTo ? filters.dateTo : undefined,
      amountFrom: filters.amountFrom ? filters.amountFrom : undefined,
      amountTo: filters.amountTo ? filters.amountTo : undefined,
      offset: filters.offset,
      limit: filters.limit,
      tenantId: filters.legalEntities ? filters.legalEntities : allLegalEntities,
      dealerId: filters.dealers? filters.dealers  : [],
      sortBy: filters.sort ? filters.sort : undefined,
      order: filters.order ? filters.order : undefined
    };
    let data = await GET("/mobility-voucher/order", true, {
      params: params,
      paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
    });
    return {
      totalElements: data["total-elements"],
      content: data.content
    };
  }

  async function getCustomer(filters: CustomerInputGetAll) {
    let params = {
      taxCode: filters.taxCode ? filters.taxCode : undefined,
      vatNumber: filters.vatNumber ? filters.vatNumber : undefined,
      cbCustomerId: filters.cbCustomerId ? filters.cbCustomerId : undefined,
      email: filters.email ? filters.email : undefined,
      firstName: filters.firstName ? filters.firstName : undefined,
      lastName: filters.lastName ? filters.lastName : undefined,
      companyName: filters.companyName ? filters.companyName : undefined,
      start: filters.start ? filters.start : undefined,
      limit: filters.limit ? filters.limit : undefined,
      sortBy: filters.sort ? filters.sort : undefined,
      order: filters.order ? filters.order : undefined
    };
    let voucherGetAllResponse: RootCustomerGetAllResponse = await GET("/mobility-vouchers/customer-base/search", true, {
      params,
      paramsSerializer: (params: CustomerInputGetAll) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
    });
    return {
      totalElements: voucherGetAllResponse?.customFields?.size,
      content: voucherGetAllResponse?.data
    };
  }

  async function getCategories() {
    let data: any = await GET("/mobility-voucher/subscription/categories", true);
    return data;
  }


  async function getProvinces() {
    let data: any = await GET("/mobility-vouchers/customer-base/province", true);
    return data;
  }

  async function getCountries() {
    let data: any = await GET("/mobility-vouchers/customer-base/countries", true);
    return data;
  }

  async function getLastOrders(category: string, subscription?: string) {
    if(category && subscription) {
      let data: any = await GET(`/mobility-voucher/order/last?category=${category}&subscription=${subscription}`, true);
      return data;
    } else if (category) {
      let data: any = await GET(`/mobility-voucher/order/last?category=${category}`, true);
      return data;
    } else if(subscription) {
      let data: any = await GET(`/mobility-voucher/order/last?subscription=${subscription}`, true);
      return data;
    } else {
      let data: any = await GET(`/mobility-voucher/order/last`, true);
      return data;
    }
}

  async function saveOrder(payload: any) {
    return await POST(`/mobility-voucher/order`, payload, true);
  }

  async function raPreAuthPaymentDispositive(req: any){
    const response = await POST(`/mobility-voucher/order/payment`, req, true);
    return response;
  }

  async function invoiceDraft(req: any){
    const response = await POST(`/mobility-voucher/order/invoiceDraft`, req, true);
    return response;
  }

  async function raPreAuthPaymentVerify(req: any){
    const response = await POST(`/mobility-voucher/order/verifyPayment`, req, true);
    return response;
  }

  async function sendVoucherMail(code: any){
    const response = await GET(`/mobility-voucher/order/sendVoucherMail/${code}`, true);
    return response.data;
  }

  async function retrieveVoucherCode(code: any){
    const response = await GET(`/mobility-voucher/order/getByCode/${code}`, true);
    return response;
  }

  async function returnVoucherCode(code: any){
    const response = await GET(`/mobility-voucher/order/returnVoucher/${code}`, true);
    return response;
  }

  async function unlockVoucher(code: any){
    const response = await GET(`/mobility-voucher/order/unlockVoucher/${code}`, true);
    return response;
  }

  async function detailsOrder(id: any){
    const response = await GET(`/mobility-voucher/order/${id}`, true);
    return response;
  }

  async function updatePayedOrder(req: any){
    const response = await POST(`/mobility-voucher/order/updatePayedOrder`, req, true);
    return response.data;
  }

  async function exportOrders(filters: any){
    let params = {
      lastName: filters.lastName ? filters.lastName : undefined,
      taxCode: filters.taxCode ? filters.taxCode : undefined,
      companyName: filters.companyName ? filters.companyName : undefined,
      vatNumber: filters.vatNumber ? filters.vatNumber : undefined,
      email: filters.email ? filters.email : undefined,
      status: filters.status ? filters.status : undefined,
      voucherCode: filters.voucherCode ? filters.voucherCode : undefined,
      bookable: filters.bookable ? filters.bookable : undefined,
      dateFrom: filters.dateFrom ? filters.dateFrom : undefined,
      dateTo: filters.dateTo ? filters.dateTo : undefined,
      amountFrom: filters.amountFrom ? filters.amountFrom : undefined,
      amountTo: filters.amountTo ? filters.amountTo : undefined
    };
    let data = await GET("/mobility-voucher/order/exportOrders", true, {
      params: params,
      responseType: 'blob',
      paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
    });
    
    return data;
  }

  async function createPayByLink(payload: any) {
    return await POST(`/pay-by-link/createpaybylinkrequest`, payload, true);
  }

  async function checkPayByLinkRequest(payload: any) {
    return await POST(`/pay-by-link/checkpaybylink`, payload, true);
  }


  return {
    getSubscription,
    getCategories,
    getLastOrders,
    getCustomer,
    getProvinces,
    getCountries,
    getOrders,
    saveOrder,
    raPreAuthPaymentDispositive,
    raPreAuthPaymentVerify,
    sendVoucherMail,
    updatePayedOrder,
    detailsOrder,
    exportOrders,
    returnVoucherCode,
    unlockVoucher,
    invoiceDraft,
    createPayByLink,
    checkPayByLinkRequest
  };
};